import { render, staticRenderFns } from "./AddBankCard.vue?vue&type=template&id=6ac99a74&"
import script from "./AddBankCard.vue?vue&type=script&lang=js&"
export * from "./AddBankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports